import BudgetPeriod from 'src/components/BudgetPeriod';
import { GridColumn } from 'src/components/GridWrapper';
import { CanUsesInitialBudgets } from 'src/components/guards/PermissionsList';
import usePermission from 'src/hooks/usePermissions';
import ActionRequiredAmountField from 'src/sections/action_required_invoices/ActionRequiredAmountField';
import GLCodeField from 'src/sections/action_required_invoices/glSummaryColumns/GLCodeField';
import TransactionLog from 'src/sections/action_required_invoices/glSummaryColumns/TransactionLog';

const useGLSummaryColumns = (): GridColumn<any>[] => {
  const usesBudgets = usePermission({ permissions: CanUsesInitialBudgets });
  return [
    {
      field: 'glCd',
      title: 'GL code',
      menu: false,
      component: GLCodeField,
      width: 200,
    },
    {
      field: 'description',
      title: 'Description',
      menu: false,
    },
    {
      field: 'accountingPeriod',
      title: 'Accounting Period',
      menu: false,
      width: 150,
      component: BudgetPeriod,
    },
    {
      field: 'poGlTotal',
      title: 'Transaction Log',
      menu: false,
      component: TransactionLog,
      width: 150,
    },
    {
      field: 'glRemainingBudget',
      title: 'Current Forecast Remaining Balance',
      menu: false,
      format: '{0:c2}',
      component: ActionRequiredAmountField,
      width: 200,
    },
    ...(usesBudgets
      ? ([
          {
            field: 'glRemainingInitialBudget',
            title: 'Current Budget Remaining Balance',
            format: '{0:c2}',
            component: ActionRequiredAmountField,
            menu: false,
            width: 200,
          },
        ] as const)
      : []),
  ];
};

export default useGLSummaryColumns;
